export default {
  banner: {
    title: "Connect every person and app on the planet",
    subtitle:
      "Authing quickly implements authentication and user management for any Web, App, and enterprise software to provide the most complete login solution for your customers and employees.",
    "try-time-tip": "Up to 8,000 MAU",
    "try-function-tip": "Experience of  3 use cases",
  },
  customer: "30000+ enterprises & developers trust Authing",
  management: {
    title: "Authing do two things for you",
    "item-one": {
      title: "Customer Identity",
      subtitle:
        "Create a secure and seamless authentication experience for your customers",
      "list-one": "Third-Party Login",
      "list-two": "Number Verification",
      "list-three": "Adaptive MFA",
      "list-four": "Single Sign-On",
      "list-five": "Universal Login",
      "list-six": "Customized Authentication",
    },
    "item-two": {
      title: "Workforce Identity",
      subtitle:
        "Protect and enable your workforce to use any technology on any device",
      "list-one": "Single Sign-On",
      "list-two": "Adaptive MFA",
      "list-three": "Private Cloud Deployment",
      "list-four": "Authorization Management",
      "list-five": "Phone Verification",
    },
  },
  api: {
    "title-dot-one": "Using ",
    "title-dot-two": "to help",
    "title-dot-three": "",
    "title-dot-one-first": "perfect API",
    "title-dot-one-second": "unified control",
    "title-dot-one-third": "flexible login",
    "title-dot-two-first": "developers",
    "title-dot-two-second": "enterprises",
    "title-dot-two-third": "customers",
    "title-dot-three-first": "",
    "title-dot-three-second": "",
    "title-dot-three-third": "",
    roi: {
      userRate: "User conversion rate",
      maintenanceCost: "Operational costs",
      developmentTime: "Developer-hours",
      dataFrom: "DATA FROM GARTNER",
    },
    doc: {
      type: "Doc",
      title: "Quick start",
      descript: "Learn how to use Authing and the API provided by Authing",
    },
    community: {
      type: "Community",
      title: "Developer Forum",
      descript: "Communicate with Authing's engineers and other developers",
    },
  },
  infrastructure: {
    title: "Identity infrastructure for cloud computing",
    subtitle:
      "Authing focus on identity and build a social infrastructure for identity sharing across all SaaS software and users to help companies build a secure modern IT infrastructure that not only protects their business, but also redefines the user experience.",
    img:
      "//files.authing.co/authing-website/home-identity-infrastructure-en.png",
  },
  application: {
    title: "Access thousands of application in Authing Partner Network",
    subtitle:
      "Authing has built an application ecosystem. Any application that users want will appear directly in Authing's integrated network.",
    toApn: "Enter",
  },
  connection: {
    title: "A safe future, Connect now",
    subtitle:
      "Authing is the foundation for secure connections between a complex identity ecology and an application ecology in which countless identities access applications and resources in a borderless way.",
  },
  certification: {
    title: "Compliance Certificates",
  },
  tryOn: {
    title: "Integrate Authing in 5 minutes",
    subtitle: "Single sign-on, authentication, authorization management, etc.",
  },
};
